console.log('lexikon-selector.js');

$(function(){

	$('html.page-lexikon-normen').eq(0).each(function(){

		var animationDuration = 500,
			scrollOffset = 20;

		var selectorClass = 'page-lexikon-selector',
			selectorItemClass = 'page-lexikon-selector-item';

		var sections_list = $('.page-lexikon-list-sections'),
			sections = $('.page-lexikon-list-section'),
			activeClass = 'active',
			sections_list_height_offset = sections_list.height(),
			selector_items = $('.' + selectorClass).find('.' + selectorItemClass);

		$('.' + selectorItemClass + ' > a').on('click', function () {

			var self = $(this),
				current_selector_item = self.closest('.' + selectorItemClass),
				new_section = $(self.data('target')),
				new_section_height = new_section.height(),
				new_section_list_height = new_section_height + sections_list_height_offset;

			if (!new_section.hasClass(activeClass)) {

				selector_items.not(current_selector_item).removeClass(activeClass);
				current_selector_item.addClass(activeClass);
				// sections_list.animate({height: new_section_list_height}, animationDuration);
				sections_list.animate({height: sections_list_height_offset}, animationDuration);
				sections.hide().removeClass(activeClass);
				new_section.fadeIn('slow').addClass(activeClass);

			} else { // click on active selector item => reset filter

				selector_items.removeClass(activeClass);
				sections_list.animate({height: sections_list_height_offset}, animationDuration);
				sections.fadeIn('slow').removeClass(activeClass);

			}

			if (ResponsiveBootstrapToolkit.is('<=xs')) {

				$(window).scrollTo('.page-lexikon-list-wrapper', animationDuration, { offset: -( $('.page-header-container').height() + $('.page-lexikon-selector-wrapper').height() ), easing: 'easeOutCubic' });

			}

			return false;

		});

		$('.page-lexikon-selector-reset').on('click', function(){

			selector_items.removeClass(activeClass);
			sections_list.animate({height: sections_list_height_offset}, animationDuration);
			sections.fadeIn('slow').removeClass(activeClass);

		});

		$(window).on('resize', function () {

			var activeSection = sections.filter('.' + activeClass),
				new_section_list_height = activeSection.height() + sections_list_height_offset;

			if (sections_list.height() !== new_section_list_height) {
				sections_list.stop().animate({height: new_section_list_height}, animationDuration);
			}

		});

		/*
		$('.page-lexikon-list-item > a').on('click', function () {

			var target = $($(this).data('target'));

			$(window).scrollTo(target, animationDuration, { offset: -($('.page-header-container').height() + scrollOffset), easing: 'easeOutCubic' });

		});
		*/


		// buttons "products with"
		$('.shop-ingredients-item-products-with-link').hover(function(){
			var self = $(this);
			self.css('color', self.data('hover-textcolor'))
				.css('backgroundColor', self.data('hover-bgcolor'));
		}, function () {
			var self = $(this);
			self.css('color', '')
				.css('backgroundColor', '');
		});

	});

});